import { jwtDecode } from "jwt-decode"
import { JWTDecoded } from "../components/Dashboard/IDashboard"
import { keycloak } from "../providers/KeycloakAuthProvider"
import { ITableHeader, TableHeaders } from "../redux/store/IStore"

export const translateHeader = (key: TableHeaders) => {
    switch (key) {
        case TableHeaders.status: return "Stanje seje"
        case TableHeaders.name: return "Ime seje"
        case TableHeaders.createdByUser: return "Uporabnik"
        case TableHeaders.labels: return "Labele"
        case TableHeaders.sources: return "Viri"
        case TableHeaders.recordedMs: return "Dolžina seje"
        case TableHeaders.createdAt: return "Datum kreiranja"
        case TableHeaders.updatedAt: return "Zadnja sprememba"
        case TableHeaders.visibility: return "Vidnost"
    }
}

export const getInitialWidthForHeader = (key: TableHeaders) => {
    const tableWidth = window.innerWidth - 224;
    
    switch (key) {
        
        case TableHeaders.status: return tableWidth * 0.2
        case TableHeaders.name: return tableWidth * 0.2
        case TableHeaders.createdByUser: return tableWidth * 0.2
        case TableHeaders.labels: return tableWidth * 0.2
        case TableHeaders.sources: return tableWidth * 0.2
        case TableHeaders.recordedMs: return tableWidth * 0.2
        case TableHeaders.createdAt: return tableWidth * 0.2
        case TableHeaders.updatedAt: return tableWidth * 0.2
        case TableHeaders.visibility: return tableWidth * 0.2
    }
}

export const handleHeadersWrapper = (newHeaders: ITableHeader[]) => {
    if (!keycloak.token) {
        return;
      }
      const decodedToken: JWTDecoded = jwtDecode(keycloak.token)
      const userSettings = localStorage.getItem(decodedToken.sub);
      if (!userSettings) {
        localStorage.setItem(decodedToken.sub, JSON.stringify({tableHeaders: newHeaders}))
        return;
      }
      const parsedSettings = JSON.parse(userSettings)
      parsedSettings.tableHeaders = newHeaders;
      localStorage.setItem(decodedToken.sub, JSON.stringify(parsedSettings))
}